module.exports = __webpack_public_path__ + "44152312989cfb1f8ae296e1774ea769.pdf";